// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
//import libs
import 'slick-carousel/slick/slick.min';
// require main js file
require('@js/index');
require('@js/header');
require('@js/sliders');
require('@js/tabs');
